<div class="m-overlay"
     ref="baseWindow">
    <slot name="trigger" />
    <portal :target-el="portalTargetSelector"
            v-if="portalCreated">
        <transition name="m--is"
                    :duration="{ enter: 800, leave: 600 }">
            <div class="m-overlay__wrap"
                 :class="[{ 'm--is-disabled':disabled},
                            className ]"
                 ref="modalWrap"
                 v-show="propOpen"
                 v-if="portalMounted">
                <section class="m-overlay__article"
                         ref="article">
                    <header class="m-overlay__header"
                            :class="{'m--no-padding': !padding || !paddingHeader}">
                        <div class="m-overlay__header-left">
                            <slot name="header" />
                        </div>
                        <div class="m-overlay__header-right"
                             v-if="$slots['header-right']">
                            <slot name="header-right" />
                        </div>
                    </header>
                    <div class="m-overlay__body"
                         :class="{'m--is-android': hasKeyboard}">
                        <div class="m-overlay__content"
                             ref="body"
                             @focusin="onFocusIn"
                             @focusout="onFocusOut"
                             :class="{ 'm--no-padding': !padding || !paddingBody }">
                            <slot />
                        </div>
                        <footer v-if="hasKeyboard && !hideFooter"
                                class="m-overlay__footer"
                                ref="footer"
                                :class="{ 'm--no-padding': !padding || !paddingFooter }">
                            <slot name="footer">
                                <m-button @click="save()"
                                          :disabled="isSaveButtonDisabled"
                                          :waiting="isWaiting"
                                          class="m-overlay__save-button">
                                    {{ 'm-overlay:save' | f-m-i18n }}
                                </m-button>
                                <m-button @click="cancel()"
                                          skin="secondary"
                                          :disabled="isWaiting">
                                    {{ 'm-overlay:cancel' | f-m-i18n }}
                                </m-button>
                            </slot>
                        </footer>
                    </div>
                    <footer v-if="!hasKeyboard && !hideFooter"
                            class="m-overlay__footer m--no-keyboard"
                            ref="footer"
                            :class="{
                                'm--no-padding': !padding || !paddingFooter,
                             }">
                        <slot name="footer">
                            <m-button @click="save()"
                                      :disabled="isSaveButtonDisabled"
                                      :waiting="isWaiting"
                                      class="m-overlay__save-button">
                                {{ 'm-overlay:save' | f-m-i18n }}
                            </m-button>
                            <m-button @click="cancel()"
                                      skin="secondary"
                                      :disabled="isWaiting">
                                {{ 'm-overlay:cancel' | f-m-i18n }}
                            </m-button>
                        </slot>
                    </footer>
                </section>
            </div>
        </transition>
    </portal>
</div>
